import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { AlphaNumericValidationService } from './alphanumericValidation.service';
import { NumericValidationService } from './numericValidation.service'

@Injectable({
  providedIn: 'root'
})
export class QuestionValidationService {

  constructor(private numericValidationService : NumericValidationService, 
    private alphaNumericValidationService : AlphaNumericValidationService) { }

  addValidation(validations: any): any[] {
     const validators: any[] = [];
      Object.entries(validations).forEach(([validation, value]) => {
          let val = JSON.parse(JSON.stringify(value));
          if(validation === 'required') {
              validators.push(Validators.required);
          } else if(validation === 'maxlength') {
              validators.push(Validators.maxLength(val?.value));
          } else if(validation === 'pattern') {
               validators.push(Validators.pattern(val?.value));
          } else if(validation === 'numeric') {
            validators.push(this.numericValidationService.checkNumericValue());
          } else if(validation === 'alphanumeric') {
            validators.push(this.alphaNumericValidationService.checkAlphaNumericValue());
          }
      });
     return validators;
}

}
